import React from 'react';
import { cn } from '@/utils/cn';
import type { ContentWrapperProps } from '@/types/layout.types';

const maxWidthMap = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-7xl',
  xl: 'max-w-[1400px]',
  full: 'max-w-full',
};

const paddingMap = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

export const ContentWrapper: React.FC<ContentWrapperProps> = ({
  children,
  className,
  maxWidth = 'xl',
  padding = 'lg',
}) => {
  return (
    <div
      className={cn(
        'mx-auto w-full',
        maxWidthMap[maxWidth],
        paddingMap[padding],
        className
      )}
    >
      {children}
    </div>
  );
};

export default ContentWrapper;